import { ISocket } from 'interfaces/redux/ISocket';
import { Reducer } from 'redux';
import { getSocket } from '../services/socket-manager';
import { windowFeatureIsEnabled } from '../config/window-features';
import {
  FaGrantNotificationActionPayload,
  IAction,
  SocketActionsEnum,
} from '../actions/action-socket';

const BASE_URL_SOCKET = 'wss://socketio.arbor.trellisrx.com';
const isRefillPage = window.location.pathname.substring(0, 9) === '/refills/';
const isDCQuestionnaire = window.location.pathname.substring(0, 16) === '/questionnaires/';

const initialState: ISocket = {
  faSocket: null,
  fcSocket: null,
  rulesEngineSocket: null,
  lastNotification: null,
  notifications: [],
  usersWorkingTasks: [],
};
export const socket: Reducer<ISocket, IAction> = (state = initialState, { type, payload }) => {
  if (type === SocketActionsEnum.UPDATE_PATIENT_TASKS_MULTIUSER) {
    return {
      ...state,
      usersWorkingTasks: payload,
    };
  }

  if (isRefillPage || isDCQuestionnaire) {
    return { ...state };
  }
  const faLinkingFeature = windowFeatureIsEnabled('fa_linking');
  const fcSelfServiceFeature = windowFeatureIsEnabled('fc_self_service');

  if (type === SocketActionsEnum.FA_GRANT_NOTIFICATION) {
    const faPayload = payload as FaGrantNotificationActionPayload;
    const notificationExists = state.notifications.some(
      notification => notification.id === faPayload.notification.id,
    );
    return {
      ...state,
      faSocket: faPayload.socket,
      lastNotification: faPayload.notification,
      notifications: !notificationExists
        ? [...state.notifications, faPayload.notification]
        : [...state.notifications],
    };
  }

  return {
    ...state,
    faSocket: !state.faSocket && faLinkingFeature ? getSocket('/fa') : state.faSocket,
    fcSocket: !state.fcSocket && fcSelfServiceFeature ? getSocket('/fc') : state.fcSocket,
    rulesEngineSocket: !state.rulesEngineSocket
      ? getSocket('/rules-engine')
      : state.rulesEngineSocket,
  };
};
